import { render, staticRenderFns } from "./ExpandedCallForwardings.vue?vue&type=template&id=5f07ef1c&"
import script from "./ExpandedCallForwardings.vue?vue&type=script&lang=ts&"
export * from "./ExpandedCallForwardings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports